import { Alert, Button, FormControl, FormGroup, Snackbar, Stack, TextField} from "@mui/material"
import React,{ useContext, useEffect,useRef, useState } from "react";
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux";
import { newTemplateActions } from "../../../../redux/slices/newTemplateSlice";
import inputValidation from "../../../../utils/inputValidation";
import { api } from "../../../../redux/api";
import { treeActions } from "../../../../redux/slices/treeSlice";
import NewInboundTemplateOptions from "../../../../constants/newTemplateWizardOptions";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { CircularProgress,Box } from '@mui/material';

export default function NtwFinish({toggle}) {
  const { t } = useTranslation()
  const [nameInput, setNameInput] = useState('');
  const [finishButtonClicked, setFinishButtonClicked] = useState(false);
  const [message,setMessage] = useState('');
  const [showAlert,setShowAlert] = useState(false);
  const [requestData, setRequestData] = useState(null);
  const [templateValid, setTemplateValid] = useState(false);
  const newTemplate = useSelector((state) => state.newTemplate);
  const { account } = useSelector((state) => state.queryParams);
  const parentScreen = useContext(ParentScreenCtx);
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const {selectedNode} = useSelector((state) => state.treeData[currentScreen].leftTree.tree.body)
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const error = useRef(null);
  const ntOption = NewInboundTemplateOptions();
  const hl7TemplateOptions = ntOption.NTW_REP_HL7_TEMPLATES
  const ediTemplateOptions = ntOption.NTW_REP_EDI_TEMPLATES
  const NCPDPOptions = ntOption.NTW_REP_NCPDP_TEMPLATES
  const FHIROptions = ntOption.NTW_REP_FHIR_TEMPLATES
  const XMLRepOptions = ntOption.NTW_REP_XML_TEMPLATES
  const validateInput = (input) => {
    const errorMsg = t("BOX_MAX_LENGTH_FOR_NAME_IS").replace(/\{0\}/, "50");

    if (!input) {
      return false;
    }

    const inputValidationResult = inputValidation(input);

    if (inputValidationResult === "invalid") {
      error.current.textContent = t(
        "BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES"
      );
      return false;
    }

    if (input.length > 50) {
      error.current.textContent = errorMsg;
      return false;
    }

    return true;
  };
  
  const textOnChange = (e) => {
    const inputValue = e.target.value;
    setNameInput(inputValue);
    error.current.textContent = "";
    dispatch(newTemplateActions.setTemplateName(inputValue))

    const isCopySelectedTemplate =
      newTemplate.newTemplateOption === ntOption.NTW_COPY_SELECTED_TEMPLATE ||
      newTemplate.newTemplateOption === ntOption.NTW_DTD_TEMPLATE ||
      newTemplate.newTemplateOption === ntOption.NTW_SQL_TEMPLATE ||
      newTemplate.newTemplateOption === ntOption.NTW_JSON_DATA ||
      newTemplate.newTemplateOption === ntOption.NTW_JSON_SCHEMA ||
      newTemplate.newTemplateOption === ntOption.NTW_DELIMITED_HEADER ||
      newTemplate.newTemplateOption === ntOption.NTW_XSD ||
      newTemplate.newTemplateOption === ntOption.NTW_XML_DATA || 
      newTemplate.newTemplateOption === ntOption.NTW_EDI_SEF ||
      hl7TemplateOptions.includes(newTemplate.newTemplateOption) ||
      ediTemplateOptions.includes(newTemplate.newTemplateOption) ||
      FHIROptions.includes(newTemplate.newTemplateOption) ||
      NCPDPOptions.includes(newTemplate.newTemplateOption) ||
      XMLRepOptions.includes(newTemplate.newTemplateOption)
    const isTemplateValid =
      validateInput(inputValue) &&
      (isCopySelectedTemplate ? handleNewTemplateData() : true);
    setTemplateValid(isTemplateValid);
  };
  
  const handleNewTemplateData = () => {
       return (
      newTemplate.copyTemplateTreeSelectedNode !== "" ||
      newTemplate.DTDTemplateData.hasOwnProperty("rootElement") ||
      // (newTemplate.RepTemplateDetails!=='' && newTemplate.SelectedRepTemplate !=='') ||
      (newTemplate.SelectedRepTemplate.hasOwnProperty('path') || newTemplate.SelectedRepTemplate.hasOwnProperty('title') ) ||
      newTemplate.SqlTemplateData !== "" ||
      newTemplate.JSONTemplateData !== "" ||
      (newTemplate.DelimitedHeaderData.hasOwnProperty("fileInfo") || newTemplate.DelimitedHeaderData.hasOwnProperty("data")) ||
      newTemplate.XSDTemplateData.hasOwnProperty("rootElement") ||
      (newTemplate.XMLTemplateData.hasOwnProperty("fileInfo") || newTemplate.XMLTemplateData.hasOwnProperty("data")) ||
      (newTemplate.EDISefTemplateData.hasOwnProperty('sefEdiSet'))  
    );
  };
  
  useEffect(() => {
    error.current.textContent = ""
    const isBasicOrJsonEmpty = [
      ntOption.NTW_BASIC_EMPTY,
      ntOption.NTW_JSON_EMPTY,
    ].includes(newTemplate.newTemplateOption);
    setTemplateValid(
      isBasicOrJsonEmpty
        ? validateInput(nameInput || newTemplate.templateName)
        : handleNewTemplateData() && validateInput(nameInput || newTemplate.templateName)
    );
     }, [
    nameInput,
    newTemplate.copyTemplateTreeSelectedNode,
    newTemplate.newTemplateOption,
    newTemplate.DTDTemplateData,
    newTemplate.RepTemplateDetails,
    newTemplate.SelectedRepTemplate,
    newTemplate.SqlTemplateData,
    newTemplate.DelimitedHeaderData,
    newTemplate.XSDTemplateData,
    newTemplate.XMLTemplateData,
    newTemplate.EDISefTemplateData,
    newTemplate.templateName,
    newTemplate.JSONTemplateData
  ]);
  
  const onClose = () => {
    dispatch(newTemplateActions.resetState());
    toggle()
  };
   
  const handleFinish = () => {
    dispatch(newTemplateActions.setTemplateName(nameInput))
    dispatch(newTemplateActions.setTemplateValid(templateValid))
    setFinishButtonClicked(true)
    setIsLoading(true)
    dispatch(newTemplateActions.setDisableTree(true))
  }
  useEffect(() => {
    const handleFinishButtonClicked = () => {
      if (!finishButtonClicked || !requestData) return;
      let formData;
      let endpoint = api.endpoints.addNewInboundTemplate;
      // let copyTemplateEndpoint = currentScreen === "inbound" ? api.endpoints.copyInboundTemplate : api.endpoints.copyOutboundTemplate
      let copyTemplateEndpoint = api.endpoints.copyInboundTemplate

      let templateListDispatchType = currentScreen === "inbound" ? 'getInboundTemplateList' : 'getOutboundTemplateList'
      if (newTemplate.isFormData) {
        endpoint = api.endpoints.addNewInboundTemplateWithFormData;
        const fileInfo =
          newTemplate.SqlTemplateData.fileInfo ||
          newTemplate.JSONTemplateData.fileInfo ||
          newTemplate.DelimitedHeaderData.fileInfo ||
          newTemplate.XSDTemplateData.fileInfo ||
          newTemplate.XMLTemplateData.fileInfo ||
          newTemplate.DTDTemplateData.fileInfo ||
          newTemplate.EDISefTemplateData.fileInfo

        
        const rawData = newTemplate?.JSONTemplateData?.data || newTemplate.DelimitedHeaderData.data || newTemplate?.XMLTemplateData.data;  

        if (fileInfo) {
           formData = new FormData()

          const fileBlob = new Blob([fileInfo], {
            type: "text/plain",
          });

          formData.append("file", fileBlob);
        } else if(rawData){
           formData = rawData;
        }
      }
      if(newTemplate.newTemplateOption === ntOption.NTW_COPY_SELECTED_TEMPLATE) {
        endpoint = copyTemplateEndpoint
      }

      const apiCallData = newTemplate.isFormData ? { requestData, data: formData } :  requestData ;
      dispatch(endpoint.initiate(apiCallData,{forceRefetch:true}))
        .then((response) => {
          if(response.error){
            error.current.textContent = response.error.message || t("BOX_MSG_GENERAL_ERROR")
          }
          if (response?.data?.current_state === 'SUCCESS') {
            if(newTemplate.generateHL7ACK){
              dispatch(api.endpoints.addNewInboundTemplate.initiate({
                account,
                newTemplateName: response.data.data.template_name || response.data.data.templateName,
                workflowGroup: encodeURIComponent(
                  selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
                ),
                file_type: "HL7",
                is_inbound: true,
                release_key: 25,
                generate_ack: true
              }))
              .then(response => {
                if(response.error){
                  setTimeout( () => {
                    dispatch(newTemplateActions.setAlertType('warning'));
                    dispatch(newTemplateActions.setShowAlert(true));
                    dispatch(newTemplateActions.setAlertMessage(response.message || response.error || t('t("BOX_MSG_GENERAL_ERROR")')))
                  },200)
                  
                }
                if(response?.data) {
                  const current_state = response?.data?.current_state;
                  
                  if(current_state === 'SUCCESS'){
                    dispatch(
                      api.endpoints.getOutboundTemplateList.initiate(
                        { account },
                        { subscribe: false, forceRefetch: true }
                      )
                    );
                  } else {
                    dispatch(newTemplateActions.setAlertType('warning'))
                  }
                  setTimeout(() => {
                    dispatch(newTemplateActions.setShowAlert(true));
                    dispatch(newTemplateActions.setAlertMessage(response.data.message))
                  },200)
                  
                }
              })
            }
            setIsLoading(false);
            const templateName = response.data.data.template_name || response.data.data.templateName
            const updatedNodeData = {
              name:templateName,
              workflowGroup:selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
            };
  
            dispatch(
              treeActions.setLeftTreeContextActionValue({ 
                screen: currentScreen,
                data: updatedNodeData
               })
            );
            dispatch(treeActions.setForceTemplate({
              workflowGroup: selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title,
              template: templateName,
              forceSelect: true,
              screen: parentScreen
            }))
            // No need to fetch template here it is getting fetched in workflowgrouptree
            dispatch(api.endpoints[templateListDispatchType].initiate({ account }, { subscribe: false,forceRefetch: true }));
            dispatch(newTemplateActions.resetState())
            setTimeout(() => {
              dispatch(newTemplateActions.setShowAlert(true));
              dispatch(
                newTemplateActions.setAlertMessage(
                  response.data.message.split("\n")[0]
                )
              );
            }, 100);
          } else {
            error.current.textContent = response?.data?.message || response?.error?.data;
            setIsLoading(false)
            dispatch(newTemplateActions.setDisableTree(false))
            dispatch(newTemplateActions.setTemplateName(''))
            setTemplateValid(false)
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (error.current) {
            error.current.textContent = error.message || "An unknown error occurred"
          }
        })
        .finally(() => {
          setFinishButtonClicked(false);
        });
    };
  
    if(newTemplate.modalOpen) handleFinishButtonClicked();
  }, [requestData,finishButtonClicked]);
  
  useEffect(()=>{
    if(newTemplate.modalOpen){
    error.current.textContent = ""
    }
  },[newTemplate.newTemplateOption])

  useEffect(() => {
    setNameInput("");
    // error.current.textContent=""
    // setTemplateValid(false);
    const requestParamsObj = {
      [ntOption.NTW_BASIC_EMPTY]: {
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "EMPTY"
      },
      [ntOption.NTW_COPY_SELECTED_TEMPLATE]: {
        account,
        sourceAccount: newTemplate.copyTemplateTreeSelectedNode?.sourceAccount,
        sourceWorkflowName:
          newTemplate.copyTemplateTreeSelectedNode?.workflowGroup,
        sourceTemplateName: newTemplate.copyTemplateTreeSelectedNode?.title,
        destinationWorkflowName: selectedNode.isLeaf
          ? selectedNode.workflowGroup
          : selectedNode.title,
        newTemplateName: newTemplate.templateName.toLowerCase(),
        is_overwrite: "",
        is_userspace: true,
        is_server: false,
        is_inbound: currentScreen === "inbound"
      },
      [ntOption.NTW_DTD_TEMPLATE]: {
        account,
        title: newTemplate.DTDTemplateData.rootElement,
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        fileName: newTemplate.DTDTemplateData.fileName,
        file_type:'DTD',
        is_inbound: currentScreen === "inbound",

      },
      [ntOption.NTW_SQL_TEMPLATE] : {
        account,
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        file_type:'SQL',
        is_inbound: currentScreen === "inbound",
        

      } ,
      [ntOption.NTW_JSON_EMPTY]: {
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "JSON_EMPTY"
      },
      [ntOption.NTW_JSON_DATA]:{
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "JSON",
        is_schema:false
      },
      [ntOption.NTW_JSON_SCHEMA]:{
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "JSON",
        is_schema:true
      },
      [ntOption.NTW_DELIMITED_HEADER] : {
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "CSV",
        record_delim: newTemplate.DelimitedHeaderData.RECORD_DELIMITER,
        field_delim: newTemplate.DelimitedHeaderData.FIELD_DELIMITER
      },
      [ntOption.NTW_XSD]:{
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "XSD",
        title:newTemplate.XSDTemplateData.rootElement
      },
      [ntOption.NTW_XML_DATA]:{
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: "XML",
        
      },
      [ntOption.NTW_EDI_SEF] :{
        account,
        workflowGroup: encodeURIComponent(
          selectedNode.isLeaf ? selectedNode.workflowGroup : selectedNode.title
        ),
        newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
        is_inbound: currentScreen === "inbound",
        file_type: 'SEF',
        sef_edi_set: newTemplate.EDISefTemplateData.sefEdiSet,
        release_key:newTemplate.EDISefTemplateData.release_key

      },
      ...(hl7TemplateOptions?.reduce((acc, item) => {
        return {
          ...acc,
          [item]: {
            account,
            newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
            workflowGroup: encodeURIComponent(
              selectedNode.isLeaf
                ? selectedNode.workflowGroup
                : selectedNode.title
            ),
            file_type: "HL7",
            copy_file: encodeURIComponent(newTemplate.SelectedRepTemplate.path),
            is_inbound: currentScreen === "inbound",
            release_key: 25,
            title: newTemplate?.SelectedRepTemplate?.title
              ? newTemplate.SelectedRepTemplate.title.split("-")[0]
              : "",
          },
        };
      }, {}) || {}),
      ...(ediTemplateOptions?.reduce((acc, item) => {
        return {
          ...acc,
          [item]: {
            account,
            newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
            workflowGroup: encodeURIComponent(
              selectedNode.isLeaf
                ? selectedNode.workflowGroup
                : selectedNode.title
            ),
            file_type: "SEF",
            copy_file: encodeURIComponent(newTemplate.RepTemplateDetails.path),
            is_inbound: currentScreen === "inbound",
            release_key: newTemplate.RepTemplateDetails.title,
            sef_edi_set: newTemplate.SelectedRepTemplate.title,
            is_repo: true,
          },
        };
      }, {}) || {}),
      ...(NCPDPOptions?.reduce((acc, item) => {
        return {
          ...acc,
          [item]: {
            account,
            newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
            workflowGroup: encodeURIComponent(
              selectedNode.isLeaf
                ? selectedNode.workflowGroup
                : selectedNode.title
            ),
            file_type: newTemplate.SelectedRepTemplate.file_type,
            copy_file: encodeURIComponent(newTemplate.SelectedRepTemplate.path),
            is_inbound: currentScreen === "inbound",
            title:newTemplate.SelectedRepTemplate.title
          },
        };
      }, {}) || {}),
      ...(FHIROptions?.reduce((acc, item) => {
        return {
          ...acc,
          [item]: {
            account,
            newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
            workflowGroup: encodeURIComponent(
              selectedNode.isLeaf
                ? selectedNode.workflowGroup
                : selectedNode.title
            ),
            file_type: 'COPY',
            copy_file: encodeURIComponent(newTemplate.SelectedRepTemplate.path),
            is_inbound: currentScreen === "inbound",
            title:newTemplate.SelectedRepTemplate.title
          },
        };
      }, {}) || {}),
      ...(XMLRepOptions?.reduce((acc, item) => {
        return {
          ...acc,
          [item]: {
            account,
            newTemplateName: encodeURIComponent(newTemplate.templateName.toLowerCase()),
            workflowGroup: encodeURIComponent(
              selectedNode.isLeaf
                ? selectedNode.workflowGroup
                : selectedNode.title
            ),
            file_type: 'COPY',
            copy_file: encodeURIComponent(newTemplate.SelectedRepTemplate.path),
            is_inbound: currentScreen === "inbound",
            title:newTemplate.SelectedRepTemplate.title
          },
        };
      }, {}) || {}),

      // Add more conditions and their corresponding requestData objects here
    };
  
    const requestData = newTemplate.templateName && requestParamsObj[newTemplate.newTemplateOption];
    requestData && setRequestData(requestData);
  }, [
    newTemplate.templateName,
    newTemplate.newTemplateOption,
    newTemplate.EDISefTemplateData,
    newTemplate.DTDTemplateData,
    newTemplate.XSDTemplateData,
    newTemplate.DelimitedHeaderData,
    newTemplate.SelectedRepTemplate
  ]);

  return (
    <>
      {/* <div className="flex"> */}
      <Stack direction="row" spacing={"8px"} style={{padding: "12px"}}>
        <TextField
          style={{flexGrow: 1}}
          InputProps={{ ref: inputRef, autoFocus: true }}
          // className="ntw-finish-text-field ntw-finish-input"
          label={t("LBL_ENTER_TEMPLATE_NAME")}
          variant="outlined"
          size="small"
          value={nameInput || newTemplate.templateName }
          onChange={textOnChange}
          autoComplete="off"
        />
        <Button
          size="small"
          // className="ntw-finish-btn"
          variant="outlined"
          color="primary"
          disabled={!templateValid}
          onClick={handleFinish}>
          {isLoading ? <CircularProgress size={"16px"} /> : t("BTN_FINISH")}
        </Button>
        <Button variant="outlined" color="primary" onClick={onClose} size="small">
          {t("CANCEL")}
        </Button>
      </Stack>
        
      
      {/* </div> */}

      <div style={{ paddingLeft: "10px" }}>
        <p className="error" ref={error}></p>
      </div>
      {/* {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "25px",
          }}>
          <CircularProgress />
        </Box>
      ) : (
        ""
      )} */}
    </>
  );
}